import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: ({ hasDiamond, hasSlideshow, isExclusiveCollection, fullWidthContent }) => {
    return {
      thRoot: 'bg-white',
      thHeader: '',
      thHeaderContainer: 'mx-auto w-full max-w-site-medium',
      thTop: classnames('relative', {
        'mb-35 lg:mb-55': hasDiamond,
        'md:mb-[11px] md:mt-54': !hasDiamond,
      }),
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroImmersive: hasSlideshow ? 'min-h-[102%] filter-[blur(10px)] opacity-25' : '',
      thSlideshow: `my-0 mx-auto w-full ${
        isExclusiveCollection ? 'bg-ultramarine' : 'bg-darkGrey'
      }`,
      thMultimediaOverlay: 'absolute inset-0 mb-10',
      thDiamond: 'absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 -mb-2',
      thDiamondClassName: 'font-bold uppercase text-10 sm:text-12 size-60 lg:size-75',
      thBody: `${fullWidthContent ? '' : 'px-20'} py-20 lg:py-15`,
      thContent: `${fullWidthContent ? '' : 'max-w-site-medium'} mx-auto w-full`,
      thFooter: 'bg-pearl overflow-hidden px-20',
    };
  },
};
